import type { LucideIcon } from "lucide-react";

const TONE_BG: Record<string, string> = {
  indigo: "bg-indigo-50 text-indigo-600 dark:bg-indigo-950/40 dark:text-indigo-400",
  violet: "bg-violet-50 text-violet-600 dark:bg-violet-950/40 dark:text-violet-400",
  emerald: "bg-emerald-50 text-emerald-600 dark:bg-emerald-950/40 dark:text-emerald-400",
  amber: "bg-amber-50 text-amber-600 dark:bg-amber-950/40 dark:text-amber-400",
  sky: "bg-sky-50 text-sky-600 dark:bg-sky-950/40 dark:text-sky-400",
  slate: "bg-slate-100 text-slate-600 dark:bg-slate-850 dark:text-slate-400",
};

/** Metric tile shared by the dashboard and the profile. */
export function StatCard({
  label,
  value,
  hint,
  icon: Icon,
  tone,
}: {
  label: string;
  value: number;
  hint?: string;
  icon: LucideIcon;
  tone: keyof typeof TONE_BG | string;
}) {
  return (
    <div className="bg-white dark:bg-slate-900 p-4 rounded-2xl border border-slate-100 dark:border-slate-800 shadow-sm">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-slate-600 dark:text-slate-300">{label}</span>
        <div className={`size-7 rounded-lg flex items-center justify-center ${TONE_BG[tone] ?? TONE_BG.slate}`}>
          <Icon aria-hidden size={20} />
        </div>
      </div>
      <div className="text-3xl font-semibold text-slate-900 dark:text-slate-100 mt-2 tabular-nums">{value}</div>
      {hint && <div className="text-xs text-slate-600 dark:text-slate-400 mt-1">{hint}</div>}
    </div>
  );
}
